export enum Launch_Netent {
  "hu" = "hu",
}
